import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  ViewChild,
  HostListener,
} from '@angular/core';

import { Mascara } from '../../util/mascara.util';

import { isNullOrUndefined } from '../../util/is-null-or-undefined.util';

import { IDropDownConfig } from './drop-down.model';

@Component({
  selector: 'app-drop-down',
  standalone: false,
  templateUrl: './drop-down.component.html',
  styleUrls: ['./drop-down.component.css'],
})
export class DropDownComponent implements OnInit, OnChanges {
  constructor(private elementRef: ElementRef) {
    // Define o valor padrão da configuração
    this.dropDownConfig = {
      fieldSearch: null,
      idItem: null,
      dropDownId: null,
    };
  }

  @ViewChild('inputItem', { static: true }) inputItem: ElementRef;

  @Input() dropDownConfig: IDropDownConfig;

  @Input() selecionaItemSomenteLeitura = false;
  @Input() selecionaItem: string = null;
  @Input() listItem: any;
  @Output() valorSelecionado: EventEmitter<any> = new EventEmitter<any>();

  public valueItem = '';
  public textoPesquisa = '';
  public exibeLista = false;
  public botaoSomenteLeitura = false;
  mascara: Mascara = new Mascara();

  /**
   * Hostlistener usado especificamente para o dropdown pois a diretiva ClickElseWhere
   *  não funciona sendo chamada pelo componente
   *
   * @param eventName
   * @param args
   *
   */
  @HostListener('document:click', ['$event'])
  public onDocumentClick(event: MouseEvent): void {
    const targetElement = event.target as HTMLElement;
    // Check if the click was outside the element
    if (
      targetElement &&
      !this.elementRef.nativeElement.childNodes[0].contains(targetElement)
    ) {
      this.removerFocusDropDown();
    }
  }

  ngOnInit() {
    this.listItem =
      this.listItem !== null && this.listItem !== undefined
        ? this.listItem
        : new Array();
  }

  ngOnChanges() {
    if (!isNullOrUndefined(this.listItem) && this.listItem.length > 0) {
      this.botaoSomenteLeitura = false;
      this.listItem.forEach((element) => {
        element.Exibe = true;
        element.Name = element[this.dropDownConfig.fieldSearch];
      });

      if (this.selecionaItemSomenteLeitura) {
        this.botaoSomenteLeitura = true;
      }
      if (!isNullOrUndefined(this.selecionaItem)) {
        const element = this.listItem.find(
          (i) =>
            i[this.dropDownConfig.fieldSearch].indexOf(this.selecionaItem) >= 0
        );
        if (element != null) {
          this.valueItem = element.Name;
          (<HTMLInputElement>this.inputItem.nativeElement).value =
            this.valueItem;
        } else {
          this.valueItem = null;
        }
      } else {
        this.valueItem = null;
      }
    } else {
      this.botaoSomenteLeitura = true;
      (<HTMLInputElement>this.inputItem.nativeElement).value = null;
    }
  }

  public pesquisarItem(event: Event) {
    const value = (<HTMLInputElement>event.target).value.toLocaleLowerCase();
    this.textoPesquisa = value;
    this.valueItem = this.textoPesquisa;
    this.listItem.forEach((element) => {
      const keys = Object.keys(element);
      if (!isNullOrUndefined(keys)) {
        const key = keys.find((k) => k === this.dropDownConfig.fieldSearch);
        if (key) {
          if (element[key].toLowerCase().indexOf(value) > -1) {
            element.Exibe = true;
            this.exibeLista = true;
            return;
          } else {
            element.Exibe = false;
            return;
          }
        }
      }
    });
    if (this.textoPesquisa == null || this.textoPesquisa.length === 0) {
      this.selecionarOpcao(null);
    }
  }

  public selecionarOpcao(item) {
    if (item !== null) {
      this.valueItem = item.Name;
      if (this.dropDownConfig.emitItem) {
        setTimeout(() => this.valorSelecionado.emit(item), 0);
      } else {
        setTimeout(() => this.valorSelecionado.emit(this.valueItem), 0);
      }
    } else {
      this.valueItem = null;
      setTimeout(() => this.valorSelecionado.emit(item), 0);
    }
    this.textoPesquisa = null;
    this.exibeLista = false;

    this.listItem.forEach((element) => {
      element.Exibe = true;
    });
  }

  public mostrarLista() {
    if (!this.botaoSomenteLeitura) {
      if (this.exibeLista) {
        this.exibeLista = false;
        this.textoPesquisa = '';
      } else {
        this.exibeLista = true;
      }
    } else {
      this.exibeLista = false;
    }

    this.listItem.forEach((element) => {
      element.Exibe = true;
    });
  }

  public removerFocusDropDown() {
    this.exibeLista = true;
    this.mostrarLista();
    if (this.inputItem.nativeElement.value.trim() !== '') {
      if (this.inputItem.nativeElement.value !== this.valueItem) {
        this.valueItem = null;
        (<HTMLInputElement>this.inputItem.nativeElement).value = null;
        setTimeout(() => this.valorSelecionado.emit(null), 0);
      }
    }
  }
}
